<ion-header>
    <ion-toolbar>
        <ion-buttons slot="end">
            <ion-button (click)="close()">X</ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>
<ion-content>
    <ion-img [src]="img|s3Link">

    </ion-img>
</ion-content>